/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Popup } from '@codex/organisms';
import { EnvironmentThemeProvider } from '@codex/themes';
import { Icon } from '@codex/icons';
import { Link, Button } from '@codex/basics';
import styled from 'styled-components';

const StyledPopup = styled(Popup)`
  display: flex;
  text-align: center;
  background: #fff;
  flex-wrap: wrap;
  
  @media only screen and (max-width: 599px) {
    margin-left: -20px;
  }
`;

const StyledCookieMessage = styled.div`
  text-align: center;
  padding: 38px 0;
  width: 574px;
  
  @media only screen and (max-width: 1024px) {
    width: auto;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
  }
`;

const StyledLogo = styled.img`
  display: block;
  margin: auto;
  width: 268px;
  height: 80px;
`;

const StyledCross = styled(Link)`
  display: inline-block;
  float: right;
  color: #000;
  padding: 10px 5px 0 5px;
  
  &:hover {
    color: #000;
  }
`;

const LinksTitle = styled.p`
  margin: 15px;
`;

const StyledLinkList = styled.span`
  display: flex;
  margin: 0 30px;
  justify-content: space-around;
  
  @media only screen and (max-width: 599px) {
    flex-direction: column;
  }
`;

const StyledLink = styled(Link)`
  @media all and (-ms-high-contrast:none) {
  flex: 1;
  -ms-flex: 1;
  -webkit-flex: 1;
  }
  
  @media only screen and (max-width: 599px) {
    padding-bottom: 12px;
    
    &:last-child {
      padding: 0;
    }
  }
`;

const WelcomeText = styled.p`
  margin-bottom: 0;
`;

const StyledButton = styled(Button)`
  margin-top: 25px;
  width: auto;
`;

class PCWorldClosure extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      display: true
    };
    this.toggleDisplayPopup = this.toggleDisplayPopup.bind(this);
  }

  toggleDisplayPopup() {
    this.setState((state) => ({ display: !state.display }));
  }

  render() {
    const { cookieMessage } = this.props;
    const { content } = cookieMessage;
    const { image, buttons, linksTitle } = content;

    const LinkList = () => content.links.map((link, count) => (
      <StyledLink href={link.url} key={count}>
        {link.title}
        {' '}
      </StyledLink>
    ));

    const BoldText = () => content.boldText.map((text, count) => (
      <span key={count}>
        <b>{text}</b>
        <br />
      </span>
    ));

    return (
      <Provider store={window.appState}>
        <EnvironmentThemeProvider>
          {this.state.display && (
          <StyledPopup
            optionalClasses={'cookieMessage'}
            title={'PCWorldClosure Popup'}
            isVisible
            hideHeaderBar
            onClose={() => this.setState({ display: false })}
          >
            <StyledCross onClick={this.toggleDisplayPopup}>
              <Icon icon={'Cross'} size={'large'} />
            </StyledCross>
            <StyledCookieMessage>
              <WelcomeText>{content.text[0]}</WelcomeText>
              <StyledLogo
                src={image.src}
                alt={image.alt}
              />
              <p>{content.text[1]}</p>
              <BoldText />
              <LinksTitle>{linksTitle}</LinksTitle>
              <StyledLinkList>
                <LinkList />
              </StyledLinkList>
              {buttons[0].type === 1
                ? (
                  <StyledButton
                    onClick={this.toggleDisplayPopup}
                    full
                  >
                    {buttons[0].title}
                  </StyledButton>
                ) : (
                  <StyledButton
                    onClick={this.toggleDisplayPopup}
                    fullv
                  >
                    {buttons[0].title}
                  </StyledButton>
                )}
            </StyledCookieMessage>
          </StyledPopup>
          )}
        </EnvironmentThemeProvider>
      </Provider>
    );
  }
}

PCWorldClosure.defaultName = 'PCWorldClosure';

PCWorldClosure.propTypes = {
  cookieMessage: PropTypes.shape({
    id: PropTypes.string.isRequired,
    priority: PropTypes.number.isRequired,
    state: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    content: PropTypes.shape({}).isRequired
  }).isRequired
};

export default PCWorldClosure;
